import React, {useEffect, useState} from 'react';
//import './css/boxicons.min.css'
import styles from "./app.module.css"
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import LoginForm from "./Auth/LoginForm/LoginForm";
import {useSelector} from "react-redux";
import {ReduxStateInt} from "./Reducer/GlobalReducer";
import RestorePass from "./Auth/RestorePass/RestorePass";
import AcceptCookie from "./FormTemplate/AcceptCookie/AcceptCookie";
import Lk from "./LK/LK";
import {Helmet} from "react-helmet";
import Header from "./Header/Header";
import SimService from "./SimService/SimService";
import PaymentSuccess from "./SimService/Payment/PaymentSuccess";
import SurkovService from "./SurkovService/SurkovService";
export const AppContext = React.createContext<any | undefined>(undefined);
declare function CDEKWidget_(param: string): void;

const onlySelfReg = false

function App() {
    const [isOpen, setIsOpen] = useState(false);
    const authToken = useSelector((state:ReduxStateInt)  => {return state.authToken})
    const isAdmin = useSelector((state:ReduxStateInt)  => {return state.isAdmin})
    const selectRegion = useSelector((state:ReduxStateInt)  => {return state.baseRegion.makeSelectRegion})




    const mainPage = () =>{
       return(
        <>
            <div className={"container-fluid no-gutters " + styles.Wrapper} >
                <Helmet>
                    <title>X-Billing</title>
                </Helmet>
                <div className={"row-fluid"}>
                    <Header/>
                </div>




                <div className={styles.mainContent}>

                    <div className={"row-fluid"} id={"mainContainer"}>
                        <Routes >

                            <Route path='/auth/restore' element={<RestorePass/>} />
                            <Route path='/lk/*' element={<Lk/>} />
                            <Route path='/' element={<LoginForm/>} />
                            <Route path='/auth' element={<LoginForm/>} />


                        </Routes>
                    </div>



                </div>
                <div className={"row-fluid"}>
                </div>


            </div>
        </>
    )
    }


    const simInfo = () =>{
        return(
            <div>TEST</div>
        )
    }



    return (
        <BrowserRouter  basename='/' >
                <Routes >
                    <Route path='/sim/service' element={<SimService/>} />
                    <Route path='/surkov/service' element={<SurkovService/>} />
                    <Route path='/payment/success' element={<PaymentSuccess/>} />
                    <Route path='/*' element={mainPage()} />
                </Routes>
        </BrowserRouter>
    );
}

export default App;
